import { useFormContext } from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import { memo } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FormTextEditor from "../../../../components/UI/TextEditor/FormTextEditor";
import { TQuestionForm } from "./QuestionSchema";

const translationPath = "page.assessments.questions.";

interface IQuestionGuidanceTextProps {
  disabled?: boolean;
}

const QuestionGuidanceTextComponent = ({
  disabled = false,
}: IQuestionGuidanceTextProps) => {
  const { t } = useTranslation();

  const { control } = useFormContext<TQuestionForm>();

  const guidanceTextPosition = useWatch({
    name: "guidanceTextPosition",
    control,
  });

  if (!guidanceTextPosition) return null;

  return (
    <Grid
      item
      xs={12}
      sm={12}
      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
    >
      <Typography>{t(translationPath + "guidance_text")}</Typography>
      <FormTextEditor
        name="guidanceText"
        readOnly={disabled}
        menuBarProps={{
          fontSize: true,
          markFormatting: true,
          selectColor: true,
          textFormatting: true,
        }}
      />
    </Grid>
  );
};

export const QuestionGuidanceText = memo(QuestionGuidanceTextComponent);
